import { fromJS } from 'immutable'
import * as actionTypes from './constants'
import { LOGOUT } from '../authentication/constants'

const initialState = fromJS({
  PinsFilterLastState: {},
  TasksFilterLastState: {}
})

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_FILTER_NEW_OPTIONS:
      return state.set('gettingFilterOptions', true)
    case actionTypes.GET_FILTER_NEW_OPTIONS_DONE:
      return state
        .set('gettingFilterOptions', false)
        .set('filterOptions', fromJS(action.filterOptions))
    case actionTypes.GET_FILTER_NEW_OPTIONS_ERROR:
      return state
        .set('gettingFilterOptions', false)
        .set('getFilterOptionsError', action.error)

    case actionTypes.CREATE_FILTER_NEW:
      return state.set('creatingFilter', true).set('createFilterError', null)
    case actionTypes.CREATE_FILTER_NEW_DONE: {
      let newState = state
        .set('creatingFilter', false)
        .set('filterId', action.filterId)
      if (action.shouldSetGlobalFilter && action.filterConfig) {
        newState = newState.setIn(
          [
            `${action.filterConfig.entity}FilterLastState`,
            action.filterConfig.projectId
          ],
          fromJS(action.filterConfig)
        )
      }
      return newState
    }

    case actionTypes.CREATE_FILTER_NEW_ERROR:
      return state
        .set('creatingFilter', false)
        .set('createFilterError', action.error)

    case actionTypes.RESET_FILTER_NEW: {
      let newState = state
      if (action.projectId) {
        newState = newState.deleteIn([
          `${action.entity}FilterLastState`,
          action.projectId
        ])
      }
      return newState
        .set('gettingFilterOptions', false)
        .set('creatingFilter', false)
        .set('filterId', null)
        .set('createFilterError', null)
        .set('resetFilter', true)
        .delete('recordsByIds')
    }

    case actionTypes.GET_USERS:
      return state
        .set('gettingUsers', true)
        .set('getUsersError', null)
        .delete('users')
    case actionTypes.GET_USERS_DONE:
      return state.set('gettingUsers', false).set('users', action.users)
    case actionTypes.GET_USERS_ERROR:
      return state.set('gettingUsers', false).set('getUsersError', action.error)

    case actionTypes.GET_DATASETS:
      return state
        .set('gettingDatasets', true)
        .set('getDatasetsError', null)
        .delete('datasets')
    case actionTypes.GET_DATASETS_DONE:
      return state
        .set('gettingDatasets', false)
        .set('datasets', action.datasets)
    case actionTypes.GET_DATASETS_ERROR:
      return state
        .set('gettingDatasets', false)
        .set('getDatasetsError', action.error)

    case actionTypes.GET_DATASET_RECORDS:
      return state.set('gettingRecords', true).delete('getRecordsError')
    case actionTypes.GET_DATASET_RECORDS_DONE: {
      const datasetId = action.datasetId
      const records = action.records.map((record) => ({
        ...record,
        idRecordText: record.record[action.columns[0]],
        titleRecordText: record.record[action.columns[1]]
      }))
      return state.set('gettingRecords', false).set(
        'records',
        state.get('records')
          ? {
              ...state.get('records'),
              [datasetId]: state.get('records')[datasetId]
                ? [...state.get('records')[datasetId], ...records]
                : records
            }
          : { [datasetId]: records }
      )
    }
    case actionTypes.GET_DATASET_RECORDS_ERROR:
      return state
        .set('gettingRecords', false)
        .set('getRecordsError', action.error)

    case actionTypes.GET_GROUPS:
      return state
        .set('gettingGroups', true)
        .delete('getGroupsError')
        .delete('groups')
    case actionTypes.GET_GROUPS_DONE:
      return state.set('gettingGroups', false).set('groups', action.groups)
    case actionTypes.GET_GROUPS_ERROR:
      return state
        .set('gettingGroups', false)
        .set('getGroupsError', action.error)
    case actionTypes.SAVE_IN_DEEP_ASYNC_DICTIONARY:
      return state.setIn(
        ['deepAsyncDictionary', action.id],
        fromJS(action.info)
      )

    case actionTypes.GET_RECORD:
      return state
        .set('gettingRecord', true)
        .delete('gerRecordError')
        .delete('record')
    case actionTypes.GET_RECORD_DONE:
      return state.set('gettingRecord', false).set('record', action.record)
    case actionTypes.GET_RECORD_ERROR:
      return state
        .set('gettingRecord', false)
        .set('gerRecordError', action.error)

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reducer
